import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DynamicScriptLoaderService {

  constructor() { }

  public loadScripts(scripts: string[], parent: HTMLElement) : void{
    for(let i = 0; i < scripts.length; i++) {
      let src = scripts[i];
      var s = document.createElement( 'script' );
      s.async = false;
      s.setAttribute( 'src', src );
      parent.appendChild( s );
    }
  }

  public loadStyles(styles: string[], parent: HTMLElement) : void {
    for(let i = 0; i < styles.length; i++) {
      let src = styles[i];
      var link = document.createElement('link');
      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.setAttribute('href', src);
      parent.appendChild(link);
    }
  }
}
